import axios from "axios";
  
export const Solicitar = async (url) => {
	const response = await 
    axios
        .get(url);
    return response.data;
};

export const Modificar = async (url, json) => {
	const response = await 
    axios
        .put(url, json);
    return response.data;
};

export const Insertar = async (url, json) => {
	const response = await 
    axios
        .post(url, json);
    return response.data;
};

export const EliminarLogico = async (url) => {
	const response = await 
    axios
        .put(url);
    return response.data;
};